// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"075c88a1","978":"bd203263"}[chunkId] + ".chunk.js";
};